import { render, staticRenderFns } from "./improvementTable.vue?vue&type=template&id=3197f0b9&scoped=true"
import script from "./improvementTable.vue?vue&type=script&lang=js"
export * from "./improvementTable.vue?vue&type=script&lang=js"
import style0 from "./improvementTable.vue?vue&type=style&index=0&id=3197f0b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3197f0b9",
  null
  
)

export default component.exports